import React from 'react';
import Table from '@components/table';
import type { TableDataDescription } from '@components/table/types.ts';
import type { PaginatedResponse } from '@types';

export type SortValue = { columnId: string | null; order: 'asc' | 'desc' | null };
export type tableDataMapper<T1, T2> = (input: PaginatedResponse<T1, T2>) => TableDataDescription;

interface Props<T1, T2> {
    data: PaginatedResponse<T1, T2>;
    tableDataMapper: tableDataMapper<T1, T2>;
    searchStateTexts: {
        noFiltersNoDataHeaderText: string;
        noFiltersNoDataSubtitleText: string;
        filtersNoDataHeaderText: string;
        filtersNoDataSubtitleText: string;
    };
    fixedColumnFlexes?: Record<string, number>;
    activeFilters?: string[];
    searchTerm?: string;
    rightAlignmentColumns?: string[];
    onSortChange?: (sort: SortValue) => void;
    onPaginationChange?: (pageNumber: number, pageSize: number) => void;
}

export function PaginatedTable<T1, T2>({
    data,
    tableDataMapper,
    fixedColumnFlexes,
    searchStateTexts,
    activeFilters = [],
    searchTerm = '',
    rightAlignmentColumns = [],
    onSortChange = () => {},
    onPaginationChange = () => {},
}: Props<T1, T2>): React.ReactElement {
    const mappedData: TableDataDescription = tableDataMapper(data);

    return (
        <Table
            data={mappedData}
            searchStateTexts={searchStateTexts}
            onSortChange={onSortChange}
            onPaginationChange={onPaginationChange}
            activeFilters={activeFilters}
            searchTerm={searchTerm}
            fixedColumnFlexes={fixedColumnFlexes}
            rightAlignmentColumns={rightAlignmentColumns}
        />
    );
}
